import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Report } from '../../models/report.model';
import { PropertyType } from '../../../shared/models/property-type';

@Component({
  selector: 'app-cadastre',
  templateUrl: './cadastre.component.html',
  styleUrls: ['./cadastre.component.scss'],
})
export class CadastreComponent {
  @Input() reportId!: string;
  @Input() cadastre!: Report.Cadastre;
  @Input() cityLabel!: string;
  @Input() cityCode!: string;
  @Input() isLoading = false;
  @Input() propertyType! : PropertyType;

  @Output() cadastreEnabled = new EventEmitter<boolean>();
  @Output() cadastreChanged = new EventEmitter<Report.Cadastre>();
  @Output() cancled = new EventEmitter<void>();

  // Clé unique pour forcer la destruction/reconstruction du composant
  editModeKey = 0;

  onEnabled(isEnabled: boolean): void {
    this.cadastreEnabled.emit(isEnabled);
  }

  onCadastreChanged(cadastre: Report.Cadastre): void {
    this.cadastre = cadastre;
  }

  onSaveSection(): void {
    this.cadastreChanged.emit(this.cadastre);
    this.resetEditMode();
  }

  onCancled(): void {
    this.cancled.emit();
    this.resetEditMode();
  }

  private resetEditMode(): void {
    // Force la destruction/reconstruction du composant enfant
    this.editModeKey++;
  }
}
